import { InjectionToken } from '@angular/core';

export const LANDING_URL = new InjectionToken<string>('LANDING_URL', {
  providedIn: 'root',
  factory: () => '',
});
